import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', background: '#080e1a',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: "'DM Sans', sans-serif", color: '#C9A84C', fontSize: 14
      }}>
        ⏳ Chargement...
      </div>
    );
  }

  return user ? children : <Navigate to="/auth" replace />;
}
